import PropTypes from 'prop-types';
import React from 'react';

const FullPageLayout = props => <div className="full-page-container">{props.children}</div>;

FullPageLayout.propTypes = {
    children: PropTypes.node,
};

FullPageLayout.defaultProps = {
    children: undefined,
};

export default FullPageLayout;
